export default __webpack_public_path__ + "static/media/primarykey.729df875.png";